var _filter, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizonBall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "400.667px",
    height: "400.666px",
    viewBox: "0 0 400.667 400.666",
    enableBackground: "new 0 0 400.667 400.666",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "objectBoundingBox",
    id: "AI_Shadow_1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0,
    dx: 0,
    result: "offsetBlurredAlpha",
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlurredAlpha"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#AI_Shadow_1)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.333,
    y1: 276.3325,
    x2: 200.333,
    y2: 124.3325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D2618"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#503723"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    style: {
      stopColor: "#9CCBE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#558EBB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M301.333,200.333c0,41.936-33.963,75.938-75.885,76c-0.038,0-50.076,0-50.114,0 c-41.974,0-76-34.026-76-76s34.026-76,76-76c0.027,0,50.056,0,50.083,0C267.352,124.377,301.333,158.387,301.333,200.333z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 99.667,
    y1: 200.457,
    x2: 301.667,
    y2: 200.457
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 187.979,
    y1: 187.374,
    x2: 212.979,
    y2: 187.374
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 188.167,
    y1: 213.499,
    x2: 213.167,
    y2: 213.499
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 188.026,
    y1: 241.42,
    x2: 213.026,
    y2: 241.42
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 188.167,
    y1: 159.374,
    x2: 213.167,
    y2: 159.374
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 180.042,
    y1: 173.405,
    x2: 220.042,
    y2: 173.405
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 180.042,
    y1: 227.499,
    x2: 220.042,
    y2: 227.499
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 170.042,
    y1: 255.332,
    x2: 230.042,
    y2: 255.332
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 170.042,
    y1: 145.333,
    x2: 230.042,
    y2: 145.333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M166.644,169.224h2.25v7.901h-1.493v-6.488h-1.627L166.644,169.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M172.84,169.025c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C171.259,169.383,171.952,169.025,172.84,169.025z M172.875,170.454 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S173.247,170.454,172.875,170.454z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M155.584,143.883h-1.466c0.04-0.852,0.307-1.523,0.803-2.011c0.496-0.489,1.133-0.733,1.91-0.733 c0.48,0,0.903,0.101,1.27,0.304c0.367,0.202,0.661,0.494,0.881,0.875c0.221,0.382,0.331,0.769,0.331,1.163 c0,0.469-0.133,0.974-0.4,1.515s-0.755,1.18-1.464,1.917l-0.887,0.935h2.816v1.391h-5.473v-0.72l2.444-2.492 c0.591-0.598,0.984-1.079,1.179-1.442c0.195-0.363,0.292-0.692,0.292-0.985c0-0.304-0.101-0.556-0.303-0.755 c-0.203-0.198-0.463-0.298-0.782-0.298c-0.322,0-0.591,0.12-0.806,0.36S155.599,143.471,155.584,143.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162.884,141.138c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C161.303,141.496,161.996,141.138,162.884,141.138z M162.918,142.567 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S163.291,142.567,162.918,142.567z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M234.958,143.784h-1.466c0.04-0.852,0.307-1.523,0.803-2.011c0.496-0.489,1.133-0.733,1.91-0.733 c0.48,0,0.903,0.101,1.27,0.304c0.367,0.202,0.661,0.494,0.881,0.875c0.221,0.382,0.331,0.769,0.331,1.163 c0,0.469-0.133,0.974-0.4,1.515s-0.755,1.18-1.464,1.917l-0.887,0.935h2.816v1.391h-5.473v-0.72l2.444-2.492 c0.591-0.598,0.984-1.079,1.179-1.442c0.195-0.363,0.292-0.692,0.292-0.985c0-0.304-0.101-0.556-0.303-0.755 c-0.203-0.198-0.463-0.298-0.782-0.298c-0.322,0-0.591,0.12-0.806,0.36S234.973,143.372,234.958,143.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M242.258,141.039c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C240.677,141.397,241.37,141.039,242.258,141.039z M242.292,142.468 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S242.665,142.468,242.292,142.468z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M224.341,169.224h2.25v7.901h-1.493v-6.488h-1.627L224.341,169.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M230.538,169.025c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C228.957,169.383,229.649,169.025,230.538,169.025z M230.572,170.454 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S230.944,170.454,230.572,170.454z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M166.644,223.224h2.25v7.901h-1.493v-6.488h-1.627L166.644,223.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M172.84,223.025c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C171.259,223.383,171.952,223.025,172.84,223.025z M172.875,224.454 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S173.247,224.454,172.875,224.454z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M224.341,223.224h2.25v7.901h-1.493v-6.488h-1.627L224.341,223.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M230.538,223.025c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C228.957,223.383,229.649,223.025,230.538,223.025z M230.572,224.454 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S230.944,224.454,230.572,224.454z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M155.584,253.883h-1.466c0.04-0.852,0.307-1.523,0.803-2.011c0.496-0.489,1.133-0.733,1.91-0.733 c0.48,0,0.903,0.101,1.27,0.304c0.367,0.202,0.661,0.494,0.881,0.875c0.221,0.382,0.331,0.769,0.331,1.163 c0,0.469-0.133,0.974-0.4,1.515s-0.755,1.18-1.464,1.917l-0.887,0.935h2.816v1.391h-5.473v-0.72l2.444-2.492 c0.591-0.598,0.984-1.079,1.179-1.442c0.195-0.363,0.292-0.692,0.292-0.985c0-0.304-0.101-0.556-0.303-0.755 c-0.203-0.198-0.463-0.298-0.782-0.298c-0.322,0-0.591,0.12-0.806,0.36S155.599,253.471,155.584,253.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162.884,251.138c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C161.303,251.496,161.996,251.138,162.884,251.138z M162.918,252.567 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S163.291,252.567,162.918,252.567z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M234.958,253.784h-1.466c0.04-0.852,0.307-1.523,0.803-2.011c0.496-0.489,1.133-0.733,1.91-0.733 c0.48,0,0.903,0.101,1.27,0.304c0.367,0.202,0.661,0.494,0.881,0.875c0.221,0.382,0.331,0.769,0.331,1.163 c0,0.469-0.133,0.974-0.4,1.515s-0.755,1.18-1.464,1.917l-0.887,0.935h2.816v1.391h-5.473v-0.72l2.444-2.492 c0.591-0.598,0.984-1.079,1.179-1.442c0.195-0.363,0.292-0.692,0.292-0.985c0-0.304-0.101-0.556-0.303-0.755 c-0.203-0.198-0.463-0.298-0.782-0.298c-0.322,0-0.591,0.12-0.806,0.36S234.973,253.372,234.958,253.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M242.258,251.039c0.577,0,1.073,0.142,1.491,0.424c0.417,0.283,0.739,0.715,0.967,1.297 c0.227,0.582,0.341,1.392,0.341,2.43c0,1.049-0.115,1.866-0.347,2.449c-0.23,0.583-0.542,1.012-0.932,1.287 c-0.39,0.273-0.883,0.411-1.477,0.411s-1.094-0.138-1.499-0.414s-0.722-0.695-0.951-1.257s-0.344-1.362-0.344-2.401 c0-1.45,0.224-2.501,0.671-3.153C240.677,251.397,241.37,251.039,242.258,251.039z M242.292,252.468 c-0.253,0-0.479,0.082-0.675,0.244c-0.196,0.163-0.347,0.443-0.45,0.841s-0.155,0.979-0.155,1.746 c0,0.999,0.119,1.689,0.356,2.071c0.238,0.381,0.546,0.572,0.924,0.572c0.365,0,0.654-0.181,0.869-0.542 c0.261-0.437,0.391-1.167,0.391-2.191c0-1.039-0.117-1.754-0.351-2.148S242.665,252.468,242.292,252.468z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizonBall);
export default __webpack_public_path__ + "static/media/horizon_ball.bcc94b5cc598f8947c1adb7ff94df91b.svg";
export { ForwardRef as ReactComponent };